module.exports = {"140825100":"龙兴镇","140825101":"三泉镇","140825102":"泽掌镇","140825103":"北张镇","140825104":"古交镇","140825105":"万安镇","140825106":"阳王镇","140825107":"泉掌镇","140825108":"横桥镇","140825400":"新绛县社区","140825498":"新绛县经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140825.json
// module id = 426
// module chunks = 0